<template>
  <div id="bul" class="container-fluid">
      <div class="row p-0 ps-4 pe-4 h-100">
        <div class="col d-flex align-items-center justify-content-center">
          <input class="ara form-control form-control-sm" type="text" placeholder="Belgelerde Ara" aria-label="Belgelerde Ara" v-model="ara_isim_anahtar">

          <div v-if="!tarihe_gore_ara" style="width: fit-content;">
            <button class="btn btn-sm" style="white-space: nowrap !important; margin-left: 10px !important;" @click="this.tarihe_gore_ara = true">Tarih Filtresi</button>
          </div>
          
          <div v-if="tarihe_gore_ara && !this.miladi_ara && !this.hicri_ara" style="margin-left: 10px;">
            <button class="btn btn-sm" style="white-space: nowrap !important; margin-left: 4px !important;" @click="this.hicri_ara = true; this.miladi_ara = false;">Hicri Takvim</button>
          </div>
          
          <div v-if="tarihe_gore_ara && !this.miladi_ara && !this.hicri_ara" style="margin-left: 10px;">
            <button class="btn btn-sm" style="white-space: nowrap !important; margin-left: 4px !important;" @click="this.miladi_ara = true; this.hicri_ara = false">Miladi Takvim</button>
          </div>
          
          <div v-if="tarihe_gore_ara && hicri_ara" style="width: 200px; margin-right: 10px; margin-left: 10px;">
            <select class="form-select form-control form-select-sm" v-model="ara_ay">
              <option v-for="(item, index) in availableMonths" :value="item.deger" :key="index">{{ item.adi }}</option>
            </select>
          </div>
          
          <div v-if="tarihe_gore_ara && hicri_ara" style="width: 200px;">
            <select class="form-select form-control form-select-sm" v-model="ara_yil">
              <option v-for="(item, index) in availableYears" :value="item.deger" :key="index">{{ item.adi }}</option>
            </select>
          </div>

          <div v-if="tarihe_gore_ara && miladi_ara" style="width: 200px; margin-right: 10px; margin-left: 10px;">
            <select class="form-select form-control form-select-sm" v-model="ara_ay">
              <option v-for="(item, index) in availableMonths" :value="item.deger" :key="index">{{ item.adi }}</option>
            </select>
          </div>

          <div v-if="tarihe_gore_ara && miladi_ara" style="width: 200px;">
            <select class="form-select form-control form-select-sm" v-model="ara_yil">
              <option v-for="(item, index) in availableYears" :value="item.deger" :key="index">{{ item.adi }}</option>
            </select>
          </div>

          <div v-if="tarihe_gore_ara && (miladi_ara || hicri_ara)" style="width: 50px;" class="d-flex align-items-center justify-content-center">
           <span class="p-2" style="cursor: pointer; color: #616C72; font-weight: 700;" @click="temizleFiltreler">X</span>
         </div>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row p-4">
        <div class='row' ref="tablocontainer">
          <div class="col-lg-12 ofset-lg-2">
            <div id="datalar" class="table-responsice" v-if="liste && liste_hazir">
              <DataTable class="table table-stripeds table-bordereds display"
              style="width:100%"
              :data="filteredList"
              :columns="stunlar"
              :options="datatablesettings">
                <thead>
                  <tr>
                    <th v-for="(item, index) in stunlar" :key="index">{{item.name}}</th>
                  </tr>
                </thead>
              </DataTable>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import 'jquery'
import DataTable from 'datatables.net-vue3'
import DataTableLib from 'datatables.net-bs5'
import responsible from 'datatables.net-responsive-bs5'
import 'datatables.net-bs5/css/dataTables.bootstrap5.css'
import 'datatables.net-buttons-bs5/css/buttons.bootstrap5.css'
import jquery from 'jquery'

DataTable.use(DataTableLib)
DataTable.use(responsible)

const columns = [
  { data: 'id', name:'Sıra No' },
  { data: 'gazete_adi', name:'Gazete Adı' },
  { data: 'sayfa', name:'Sayı / Sayfa',
   render: function (data, type, row) {
              let sayi = row.gazete_sayi;
              if(sayi === "0"){
                sayi = "Bilinmiyor"
              }
            return sayi+"/"+( data || '-');
        }},
  { data: 'miladi', name:'Miladi' },
  { data: 'hicri', name:'Hicri' },
  { data: 'aciklama', name:'Özet'}
];

export default {
  name: 'BoaListeler',
  components: {
    DataTable
  },
  data() {
    return {
      scrollX: true,
      products: null,
      stunlar: columns,
      datatablesettings: {
        autoWidth: true,
        select: true,
        searching: false,
        ordering: false,
        pageLength: 50, // Varsayılan sayfa başına 50 kayıt
        dom: 'Bfrtip',
        "language": {url: "./datatable-tr.json",
          paginate: {
            previous: "Önceki",
            next: "Sonraki"
          }
        },
        order: [3, 'asc'],
        drawCallback: function () {
          jquery('.paginate_button:not(.disabled)', this.api().table().container())          
            .on('click', function(){
                // pagination click handler
            });       
        },
        responsive: true,
        columnDefs: [
          {
            type: 'turkish',
            targets: this.sutun_ayarlari(),
            visible: false,
          }
        ]
      },
      liste: false,
      liste_hazir: false,
      ara_ay: "",
      ara_yil: "",
      ara_isim_anahtar: "",
      hicri_yillar: [],
      miladi_yillar: [],
      hicri_aylar: [],
      miladi_aylar: [],
      tarihe_gore_ara: false,
      hicri_ara: false,
      miladi_ara: false,
      paginationObserver: null
    }
  },
  computed: {
    filteredList() {
      if (!this.liste) return [];
      
      return this.liste.filter(items => {
        // Tarih filtresi kontrolü
        let tarih_uygun = true;
        
        if (this.hicri_ara) {
          // Hicri takvim filtresi
          if (this.ara_yil && items.yil_hicri) {
            tarih_uygun = tarih_uygun && String(items.yil_hicri) === this.ara_yil;
          }
          if (this.ara_ay && items.ay_hicri) {
            tarih_uygun = tarih_uygun && String(items.ay_hicri).padStart(2, '0') === this.ara_ay;
          }
        } else if (this.miladi_ara) {
          // Miladi takvim filtresi
          if (this.ara_yil && items.yil_miladi) {
            tarih_uygun = tarih_uygun && String(items.yil_miladi) === this.ara_yil;
          }
          if (this.ara_ay && items.ay_miladi) {
            tarih_uygun = tarih_uygun && String(items.ay_miladi).padStart(2, '0') === this.ara_ay;
          }
        }
        
        // Metin araması
        let metin_uygun = true;
        if (this.ara_isim_anahtar.trim() !== "") {
          const anahtar = this.ara_isim_anahtar.toLowerCase();
          metin_uygun = (items.keys && items.keys.toLowerCase().includes(anahtar)) || 
                       (items.aciklama && items.aciklama.toLowerCase().includes(anahtar));
        }
        
        return tarih_uygun && metin_uygun;
      });
    },
    
    // Seçilen yıla göre dinamik ay listesi
    availableMonths() {
      if (!this.liste) {
        return this.hicri_ara ? this.hicri_aylar : this.miladi_aylar;
      }
      
      const months = [{"adi": "Tüm Aylar", "deger": ""}];
      const monthSet = new Set();
      
      // Seçilen yıla göre mevcut ayları bul
      this.liste.forEach(item => {
        const yearField = this.hicri_ara ? 'yil_hicri' : 'yil_miladi';
        const monthField = this.hicri_ara ? 'ay_hicri' : 'ay_miladi';
        
        // Eğer yıl seçilmişse, sadece o yıldaki ayları göster
        if (this.ara_yil) {
          if (String(item[yearField]) === this.ara_yil && item[monthField]) {
            monthSet.add(parseInt(item[monthField]));
          }
        } else {
          // Yıl seçilmemişse tüm ayları göster
          if (item[monthField]) {
            monthSet.add(parseInt(item[monthField]));
          }
        }
      });
      
      // Ay listesini oluştur
      const monthNames = this.hicri_ara ? {
        1: "Muharrem (1.Ay)",
        2: "Safer (2.Ay)", 
        3: "Rebiülevvel (3.Ay)",
        4: "Rebiülahir (4.Ay)",
        5: "Cemaziyelevvel (5.Ay)",
        6: "Cemaziyelahir (6.Ay)",
        7: "Recep (7.Ay)",
        8: "Şaban (8.Ay)",
        9: "Ramazan (9.Ay)",
        10: "Şevval (10.Ay)",
        11: "Zilkade (11.Ay)",
        12: "Zilhicce (12.Ay)"
      } : {
        1: "Ocak", 2: "Şubat", 3: "Mart", 4: "Nisan",
        5: "Mayıs", 6: "Haziran", 7: "Temmuz", 8: "Ağustos",
        9: "Eylül", 10: "Ekim", 11: "Kasım", 12: "Aralık"
      };
      
      const sortedMonths = Array.from(monthSet).sort((a, b) => a - b);
      sortedMonths.forEach(month => {
        months.push({
          "adi": monthNames[month] || `Ay ${month}`,
          "deger": String(month).padStart(2, '0')
        });
      });
      
      return months;
    },
    
    // Seçilen aya göre dinamik yıl listesi
    availableYears() {
      if (!this.liste) {
        return this.hicri_ara ? this.hicri_yillar : this.miladi_yillar;
      }
      
      const years = [{"adi": "Tüm Yıllar", "deger": ""}];
      const yearSet = new Set();
      
      // Seçilen aya göre mevcut yılları bul
      this.liste.forEach(item => {
        const yearField = this.hicri_ara ? 'yil_hicri' : 'yil_miladi';
        const monthField = this.hicri_ara ? 'ay_hicri' : 'ay_miladi';
        
        // Eğer ay seçilmişse, sadece o aydaki yılları göster
        if (this.ara_ay) {
          if (String(item[monthField]).padStart(2, '0') === this.ara_ay && item[yearField]) {
            yearSet.add(parseInt(item[yearField]));
          }
        } else {
          // Ay seçilmemişse tüm yılları göster
          if (item[yearField]) {
            yearSet.add(parseInt(item[yearField]));
          }
        }
      });
      
      const sortedYears = Array.from(yearSet).sort((a, b) => a - b);
      sortedYears.forEach(year => {
        years.push({
          "adi": String(year),
          "deger": String(year)
        });
      });
      
      return years;
    }
  },
  mounted() {
    window.addEventListener("click", this.myClicks);
  },
  unmounted() {
    window.removeEventListener("click", this.myClicks);
  },
  created() {
    this.liste_getir();
    this.dedectTableHeight();
  },
  watch: {
    ara_isim_anahtar: function (newValue, oldValue) {
      if (newValue !== oldValue && newValue !== " ") {
        this.highlight();
        this.set_hicri_yillar();
      }
    },
    ara_ay: function() {
      this.highlight();
    },
    ara_yil: function() {
      this.highlight();
    },
    hicri_ara: function(newVal) {
      if (newVal) {
        this.set_yillar_listesi();
      }
    },
    miladi_ara: function(newVal) {
      if (newVal) {
        this.set_yillar_listesi();
      }
    }
  },
  methods: {
    temizleFiltreler() {
      this.ara_yil = '';
      this.ara_ay = '';
      this.miladi_ara = false;
      this.hicri_ara = false;
      this.tarihe_gore_ara = false;
    },
    
    // Yıl ve ay seçimi arasında uyumsuzluk varsa temizle
    validateSelections() {
      if (this.ara_yil && this.ara_ay) {
        const yearField = this.hicri_ara ? 'yil_hicri' : 'yil_miladi';
        const monthField = this.hicri_ara ? 'ay_hicri' : 'ay_miladi';
        
        // Seçilen yıl-ay kombinasyonunun varlığını kontrol et
        const exists = this.liste.some(item => 
          String(item[yearField]) === this.ara_yil && 
          String(item[monthField]).padStart(2, '0') === this.ara_ay
        );
        
        if (!exists) {
          // Uyumsuzluk varsa en son seçileni koru, diğerini temizle
          // Bu örnekte yılı koruyup ayı temizliyoruz
          this.ara_ay = '';
        }
      }
    },
    
    set_yillar_listesi() {
      if (!this.liste) return;
      
      function onlyUnique(value, index, array) {
        return array.indexOf(value) === index;
      }
      
      let yil_list = [];
      const yil_field = this.hicri_ara ? 'yil_hicri' : 'yil_miladi';
      
      this.liste.forEach(element => {
        if (element[yil_field]) {
          yil_list.push(element[yil_field]);
        }
      });
      
      const unique = yil_list.filter(onlyUnique).sort((a, b) => a - b);
      const new_uniq = [{"adi": "Tüm Yıllar", "deger": ""}];
      
      unique.forEach(element => {
        new_uniq.push({"adi": String(element), "deger": String(element)});
      });
      
      if (this.hicri_ara) {
        this.hicri_yillar = new_uniq;
      } else {
        this.miladi_yillar = new_uniq;
      }
    },
    
    set_hicri_yillar() {
      this.set_yillar_listesi();
    },
    
    dedectTableHeight() {
      // Table height detection logic
    },
    
    myClicks(e) {      
      if ((typeof e.target.attributes.class !== 'undefined') && 
          e.target.attributes.class["value"] === 'page-link') {
        this.highlight();
      }
    },
    
    applyPaginationStyle() {
      // CSS'i head'e inject et (en güçlü yöntem)
      this.injectPaginationCSS();
      
      // MutationObserver ile sürekli kontrol et
      if (!this.paginationObserver) {
        this.paginationObserver = new MutationObserver(() => {
          this.setPaginationColor();
          this.injectPaginationCSS();
        });
      }
      
      // İlk kez uygula
      this.setPaginationColor();
      
      // Pagination container'ı gözle
      const paginationContainer = document.querySelector('.dataTables_paginate');
      if (paginationContainer) {
        this.paginationObserver.observe(paginationContainer, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style']
        });
      }
    },
    
    injectPaginationCSS() {
      // Eğer zaten varsa çıkar
      const existingStyle = document.getElementById('custom-pagination-style');
      if (existingStyle) {
        existingStyle.remove();
      }
      
      // Yeni style element oluştur
      const style = document.createElement('style');
      style.id = 'custom-pagination-style';
      style.textContent = `
        .paginate_button.page-item.active .page-link {
          background-color: red !important;
          border-color: red !important;
          color: white !important;
        }
        
        .pagination .page-item.active .page-link {
          background-color: red !important;
          border-color: red !important;
          color: white !important;
        }
        
        /* Bootstrap 5 CSS Variables Override */
        :root {
          --bs-pagination-active-bg: red !important;
          --bs-pagination-active-border-color: red !important;
          --bs-pagination-active-color: white !important;
        }
        
        /* Süper agresif selector */
        body div.dataTables_paginate ul.pagination li.paginate_button.page-item.active a.page-link,
        body .dataTables_wrapper .dataTables_paginate .pagination .page-item.active .page-link {
          background-color: red !important;
          border-color: red !important;
          color: white !important;
        }
      `;
      
      // Head'in en sonuna ekle (Bootstrap'tan sonra gelsin)
      document.head.appendChild(style);
    },
    
    setPaginationColor() {
      const activeButtons = document.querySelectorAll('.paginate_button.page-item.active .page-link');
      activeButtons.forEach(button => {
        // CSS sınıfı ekle (daha güçlü)
        button.classList.add('custom-active-pagination');
        
        // Style attribute da ekle
        button.style.setProperty('background-color', 'red', 'important');
        button.style.setProperty('border-color', 'red', 'important');
        button.style.setProperty('color', 'white', 'important');
        
        // CSS text'ini değiştir
        button.style.cssText += 'background-color: red !important; border-color: red !important; color: white !important;';
      });
    },
    
    bhb(str) {
      const specialLetters = { "i": "İ", "ş": "Ş", "ğ": "Ğ", "ü": "Ü", "ö": "Ö", "ç": "Ç", "ı": "I" };
      const letters = { "İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ö": "ö", "Ç": "ç" };
      const arr = str.split(' ');
      for (let i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).replace(/(([iışğüçö]))/g, function (letter) { 
          return specialLetters[letter]; 
        }).toUpperCase() + arr[i].substr(1).replace(/(([İIŞĞÜÇÖ]))/g, function (letter) { 
          return letters[letter]; 
        }).toLowerCase();
      }
      return arr.join(" ");
    },
    
    highlight() {
      const aranan = this.ara_isim_anahtar;
      if (aranan.trim() !== "") {
        setTimeout(() => {
          jquery('td').each(function() {
            const temizlestep1 = jquery(this).text();
            const marktemizle = temizlestep1.replaceAll("<mark>", "");
            const temiztext = marktemizle.replaceAll("</mark>", "");
            const textToSearch = aranan.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const pattern = new RegExp(`${textToSearch}`, "gi");
            const newtext = temiztext.replace(pattern, match => `<mark>${match}</mark>`);
            jquery(this).html(newtext);
          });
        }, 0);
      }
    },
    
    liste_getir() {
      const formData = new FormData();
      axios({
        method: 'post',
        responseType: 'json',
        url: 'islemler.php',
        data: formData
      }).then((response) => {
        this.liste = response.data.boa_data;
        this.hicri_yillar = response.data.hicri_yillar || [{"adi": "Tüm Yıllar", "deger": ""}];
        this.miladi_yillar = response.data.miladi_yillar || [{"adi": "Tüm Yıllar", "deger": ""}];
        this.hicri_aylar = response.data.hicri_aylar || [{"adi": "Tüm Aylar", "deger": ""}];
        this.miladi_aylar = response.data.miladi_aylar || [{"adi": "Tüm Aylar", "deger": ""}];
        this.liste_hazir = true;
        
        // Debug: 1868 yılındaki kayıtları kontrol et
        console.log("1868 yılı kayıtları:", this.liste.filter(item => item.yil_miladi == 1868));
      }).catch((error) => {
        console.error('Veri yüklenirken hata:', error);
      });
    },
    
    getCookie(cname) {
      const name = cname + "=";
      const decodedCookie = decodeURIComponent(document.cookie);
      const ca = decodedCookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    
    setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      const expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    
    sutun_ayarlari() {
      const sutunlar = this.getCookie("sutunlar").split(',').map(Number);
      if (this.getCookie("sutunlar").length > 0) {
        return sutunlar;
      } else {
        const default_sutunlar = '';
        return default_sutunlar.split(',').map(Number);
      }
    }
  }
}
</script>

<style scoped>
#bul{
  height: 66px !important;
  background-color: #5b5a3f;
}
.ara{
  max-width: 600px;
}
input[type="text"],select, button.btn{
  border:1px solid #797857;
  box-shadow:none !important;
  background-color: #797857;
  outline: none !important;
}
button.btn:hover{ background-color: #918f5f;}
input[type="text"]:focus-visible, select {
outline: none;
box-shadow:none !important;
border:1px solid #616C72;
background-color: rgb(171, 171, 171) !important;
transition: all .28s;
}
.footer {
    position: fixed;
    height: 100px;
    bottom: 0;
    width: 100%;
}
#header{background-color: #f1f2f2;
padding-bottom: 26px !important;}
.logo{ width: 300px !important;}
mark{ padding: 0px !important; background-color: rgba(0,0,0,0) !important; 
  color:rgb(230, 20, 118) !important; font-weight: 700 !important;}
  .ikonnew{
  margin-right: 8px;
  }
  
  h1 span{
  font-weight: 400;
  }
  
  h1{
  
  font-weight: 700;
  
  
  }
  
  table th{
  font-size: 16px;
  }
  
  table td{
    font-family: proxima-nova, sans-serif;
  font-weight: 400;
  font-style: normal;
  }
  th:nth-child(1){
    width: 120px;
  }
  th:nth-child(3), th:nth-child(4){
    width: 120px;
  }
  
  .isaretle{
    font-weight: 700;
    color:rgb(230, 20, 118);
  }



  
</style>

<style>
  /* Bootstrap pagination tema renkleri - en basit yöntem */
  .pagination .page-item .page-link {
    color:#797857
  }

  .pagination .page-item.active .page-link {
    background-color: #797857 !important; /* Bootstrap danger color */
    border-color: #797857 !important;
    color: white !important;
  }

  .pagination .page-link:hover {
    background-color: #a09e78 !important;
    border-color: #a09e78 !important;
    color: white !important;
  }

</style>